<template>
  <http-patch-button
    v-bind="$props"
    :value="patches"
    :href="`/api/metadata/cloudaccounts/${(value || {}).id}`"
    version="v2"
    v-on="$listeners"
    @http4xx="onError"
  >
  </http-patch-button>
</template>

<i18n>
{
    "en": {
        "patchCloudAccountButton.errorMessage": "There was an error encountered while updating this cloud connection. If everything looks right please contact support so we can help you :)"
    }
}
</i18n>

<script>
import { toastError } from "@/components/Common/Toast.vue";
import HttpPatchButton from "@/components/Common/HttpPatchButton.vue";

export default {
  props: {
    ...HttpPatchButton.props,
    form: {
      type: String
    },
    value: {
      type: Object,
    },
    patches: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onError() {
      toastError(this.$t("patchCloudAccountButton.errorMessage"));
    },
  },
};
</script>